<script setup lang="ts">
import { flattenEntity } from 'strapi-flatten-graphql'
import type { FeaturedBoxes } from '~/models/Strapi'

interface Props {
  datas: FeaturedBoxes
}

const props = defineProps<Props>()
const flattenData = {
  ...props.datas,
  items: props.datas.items.map(item => ({
    ...item,
    icon: !isEmpty(item.icon?.data) ? flattenEntity(item.icon?.data)?.url : null,
  })),
}
</script>

<template>
  <BaseAtomsSkeletonBounded y-padding="lg" class="text-gray-700 !p-0">
    <h3 class="font-serif !leading-snug text-2xl md:text-3xl font-bold max-w-620px mb-8">
      {{ flattenData.title }}
    </h3>
    <div v-if="flattenData.items.length > 0" class="lg:grid lg:grid-cols-3 gap-y-10 gap-x-6">
      <div v-for="(item, i) in flattenData.items" :key="`slice-item-${i}`" class="w-full mb-4 lg:mb-0 bg-gray-100 p-4 md:p-6 rounded-sm space-y-4">
        <img v-if="item.icon" loading="lazy" class="max-w-40px max-h-40px" :src="item.icon" alt="product icon">
        <p class="text-indigo-700 text-medium">
          {{ item.subtitle }}
        </p>
        <p class="font-bold text-lg mb-1">
          {{ item.title }}
        </p>
        <div class="text-sm">
          {{ item.description }}
        </div>
      </div>
    </div>
  </BaseAtomsSkeletonBounded>
</template>
